<dx-drop-down-box [placeholder]="dataNoteGroups && dataNoteGroups.length !== 0 ? dataNoteGroups[0].dataNote.Note : 'Add Note' "
  [dropDownOptions]="{width: '600px', height: '250px'}"
  data-cy="note-inline-dropdown">
  <div #scrollContainer *dxTemplate="let data of 'content'" style="overflow-y: scroll; height: 100%;" data-cy="note-inline-scroll-container">
    @for (noteGroup of dataNoteGroups; track noteGroup; let i = $index) {
      <div [class.mb-3]="i !== dataNoteGroups.length-1" data-cy="note-inline-note-group">
        <app-note-viewer [editable]="true"
          [dataNote]="noteGroup.dataNote"
          [dataNoteCategoryEnums]="dataNoteCategoryEnums"
          [dataNoteTypeEnums]="dataNoteTypeEnums"
          [compactView]="true"
          data-cy="note-inline-viewer">
        </app-note-viewer>
        <div class="row w-100" data-cy="note-inline-controls">
          <div class="col-4">
            <button mat-button color="primary" (click)="createNewNote()" data-cy="note-inline-add-button">
              <i class="material-icons">note_add</i>
            </button>
          </div>
          <div class="col-4 text-center" style="font-size: 27px" data-cy="note-inline-pagination">
            {{i + 1}}/{{dataNoteGroups.length}}
          </div>
          <div class="col-4 text-right">
            @if (noteGroup.isEditable) {
              <button mat-button color="primary" data-cy="note-inline-delete-button">
                <i class="material-icons">delete</i>
              </button>
            }
          </div>
        </div>
        @if (i !== dataNoteGroups.length-1) {
          <mat-divider class="mt-2" data-cy="note-inline-divider"></mat-divider>
        }
      </div>
    }
  </div>
</dx-drop-down-box>
